// The only seam between the rewards row and the loyalty provider (Flits). Keep
// provider names confined to this file so swapping providers is a one-file change.
// Every call below is still a stub — wire the real provider calls here.
// Safe to delete: cart-rewards.js reaches it through optional chaining only.
const STUB_CODE_PREFIX = 'REWARD';

window.CartRewardsAdapter = {
  // Unused: the balance is server-rendered from a customer metafield so it
  // survives a morph without a fetch. Swap point if it must come from Flits.
  getBalance: async () => 0,

  // Unused: tiers are server-rendered from the `reward_tier` metaobject.
  getTiers: async () => [],

  // Resolves a code that does not exist in admin, so Shopify rejects it and the
  // promo rejection path paints the error. Create a real `REWARD<n>` discount to
  // demo the happy path.
  requestRedemptionCode: async (amount) => {
    if (!amount || amount <= 0) return null;
    return `${STUB_CODE_PREFIX}${amount}`;
  },
};
